import { FC, HTMLAttributes } from 'react'

interface ArrowTopIconProps extends HTMLAttributes<SVGElement> {
  color?: string
  width?: number
  height?: number
}

export const ArrowTopIcon: FC<ArrowTopIconProps> = ({
  color,
  width = 16,
  height = 10,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 8.5L8 1.5L15 8.5"
      stroke={color || '#ffffff'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
